import CryptoJS from 'crypto-js/crypto-js';
import { getConfigKey } from "@/api/system/config";

// 缓存从后端获取的 key 和 iv（初始为 null）
let cachedKey = null;
let cachedIv = null;
// 标记是否已初始化
let isInitialized = false;

// 1. 初始化密钥：用 then() 链式调用获取，不使用 async/await
export  function initAesKeys() {
  // 避免重复请求
  if (isInitialized) return;
  // 调用后端接口（假设 getConfigKey 返回 Promise）
  getConfigKey("sys.default.keyIv")
    .then(function(res) {
      const keyIv = JSON.parse(res.msg);
      console.log(keyIv);
      cachedKey = CryptoJS.enc.Utf8.parse(keyIv.key);
      cachedIv = CryptoJS.enc.Utf8.parse(keyIv.iv);
      isInitialized = true;
    })
    .catch(function(err) {
      console.error('AES密钥获取失败', err);
      isInitialized = true;
    });
}

// 2. 加密函数（同步，使用缓存的密钥）
export function encryptAes(word) {
  if (!isInitialized) {
    throw new Error('AES密钥未初始化，请先调用 initAesKeys()');
  }

  const srcs = CryptoJS.enc.Utf8.parse(word);
  const encrypted = CryptoJS.AES.encrypt(srcs, cachedKey, {
    iv: cachedIv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.ZeroPadding
  });
  return CryptoJS.enc.Base64.stringify(encrypted.ciphertext);
}

// 3. 解密函数（同步，使用缓存的密钥）
export function decryptAes(word) {
  if (!isInitialized) {
    throw new Error('AES密钥未初始化，请先调用 initAesKeys()');
  }

  const base64 = CryptoJS.enc.Base64.parse(word);
  const src = CryptoJS.enc.Base64.stringify(base64);
  const decrypt = CryptoJS.AES.decrypt(src, cachedKey, {
    iv: cachedIv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.ZeroPadding
  });
  return decrypt.toString(CryptoJS.enc.Utf8);
}
